import React from "react";

const PlaceHolder = () => {
    return (
        <div className="placeholder">
            <h2 className="msg">$ check back later...</h2>
        </div>
    )
}

export default PlaceHolder